import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import axios from "axios";
import JSZip from "jszip";
import { jsPDF } from "jspdf";
import Barcode from "react-barcode";
import DocViewer from "@cyntler/react-doc-viewer";

import { MdOutlinePictureAsPdf, MdOutlineEdit } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import { PiX, PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline, IoClose } from "react-icons/io5";
import { BsDownload } from "react-icons/bs";

import BrowseUploadButton from "../../common/button/browseUploadButton";
import PrintDownloadButton from "../../common/button/printDownloadButton";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import FileUploader from "../../common/fileupload";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import CancelButton from "../../common/button/cancelButton";
// import PreRequisiteModal from "./preRequisiteModal";
// import Prerequesite from "./preRequesite";
import MasterModel from "../createMaster/masterModel";
import CreateMasterModal from "../masterForm/modals/createMasterModal";
import modifyWordFileCard from "../../common/wordFilemodify";
import image from "../../assets/images/image.png";
import pdf from "../../assets/images/uploads/pdf.png";

import masterFormsActions from "../../redux/masterForms/actions";
import masterActions from "../../redux/master/actions";
import commonActions from "../../redux/common/actions";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import { NumbersValidation } from "../../utils/validation";
import { API_URL } from "../../utils/constants";
import { styled, Switch } from "@mui/material";
import capRegistrationActions from "../../redux/capRegistration/actions";
import capVerifierActions from "../../redux/capVerifier/actions";

export default function AddCapverifier() {
  const navigate = useNavigate();
  const location = useLocation();
  const now = new Date();
  const dispatch = useDispatch();
  const today = new Date();
const capVerifierId = 2;
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    resetForm,
    formState: { errors },
  } = useForm();

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const { courseList } = useSelector((state) => state.masterReducer);
  const { capDocuments } = useSelector((state) => state.capReducer);
  const { capCourseList } = useSelector((state) => state.capReducer);
  const { capVerifier } = useSelector((state) => state.capVerifierReducer);
console.log('capCourseList---',capCourseList);
console.log('capVerifier---',capVerifier);



  const handleAddCapVerifier = (data) => {
    console.log("addcoursedata--", data);
     data['ispasswordupdated'] = '0';
   
     dispatch({
      type: capVerifierActions?.CREATE_CAP_VERIFIER,
      payload: {
        data: data,
        navigate: navigate,
        resetForm: resetForm,
        reset: reset,
      },
    });
  
  };

  const handleUpdateCapVerifier = (data) => {
    console.log("addcoursedata--", data);

    // data["capcourseid"] = capid;

    data['ispasswordupdated'] = '0';

    dispatch({
      type: capRegistrationActions.UPDATE_CAP_COURSE,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };

  const selectedCategory = watch("coursecategory");
  const capid = 1

  const filteredCourses = courseList?.all?.filter(
    (course) => parseInt(course.coursecategoryid) == parseInt(selectedCategory)
  );


  console.log("courseList----", courseList);
  console.log("filteredCourses----", filteredCourses);
  console.log("selectedCategory----", selectedCategory);


  // const documentOptions = [
  //   { id: 1, label: "10, +2 marksheet" },
  //   { id: 2, label: "CET/NEET Score card" },
  //   { id: 3, label: "Identity proof" },
  //   { id: 4, label: "Domicile certificate" },
  // ];

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleChange = (event) => {
    setSelectedDocs(event.target.value);
  };

  const capDocumentOptions =
    capDocuments?.map((doc) => ({
      id: parseInt(doc.documenttypeid),
      label: doc.documenttype,
    })) || [];

  const handleFileUpload = (e, id, documenttype, status, isactive) => {
    dispatch({
      type: capRegistrationActions.UPLOAD_DOCUMENT,
      payload: {
        documenttypeid: parseInt(id),
        file: e.target.files[0],
        userid: parseInt(backofficeTokenDetails?.id),
        documenttype: documenttype,
        status: status,
        isactive: isactive,
      },
    });
  };

  const handleRemoveFile = (id, documenttype, status, isactive) => {
    console.log("documentstatus ", status);
    console.log("documenttype in rem", documenttype);

    dispatch({
      type: capRegistrationActions.REMOVE_DOCUMENT,
      payload: {
        documenttypeid: parseInt(id),
        userid: parseInt(backofficeTokenDetails?.id),
        documenttype: documenttype,
        status: status,
        isactive: isactive,
      },
    });
  };

useEffect(()=>{

if(capVerifierId && !capVerifier){

 dispatch({
    type: capVerifierActions?.GET_CAP_VERIFIER_BY_ID,
    payload:capid
  });


}
reset({...capVerifier})
  // dispatch({
  //   type: capRegistrationActions.GET_ALL_CAP_COURSE,
  // });



},[capVerifier])


  return (
    <>
      <Typography variant="h5" mb={3}>
        Add cap verifier
      </Typography>

      <Grid container spacing={3} mb={3}>
      
     
        <Grid item xs={12} md={6}>
          <TextField
            {...register("verifiername", {
              required: "verifier name is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("verifiername"),
            }}
            error={!!errors.verifiername}
            helperText={errors.verifiername?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                Verifier name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("verifiername", value);
              trigger("verifiername");
            }}
          />
        </Grid>
   
        <Grid item xs={12} md={6}>
          <TextField
            {...register("designation", {
              required: "designation is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("designation"),
            }}
            error={!!errors.designation}
            helperText={errors.designation?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                Designation
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("designation", value);
              trigger("designation");
            }}
          />
        </Grid>
   
        <Grid item xs={12} md={6}>
          <TextField
            {...register("emailid", {
              required: "emailid  is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("emailid"),
            }}
            error={!!errors.emailid}
            helperText={errors.emailid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                emailid
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("emailid", value);
              trigger("emailid");
            }}
          />
        </Grid>
   
        <Grid item xs={12} md={6}>
          <TextField
            {...register("password", {
              required: "password  is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("password"),
            }}
            error={!!errors.password}
            helperText={errors.password?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                password
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("password", value);
              trigger("password");
            }}
          />
        </Grid>

<Grid item xs={12} md={6}>
  <FormControl error={!!errors.capcourse} fullWidth size="small">
    <InputLabel id="capcourse-label">
      <span>
        Select Exam
        <span className="error" style={{ color: "red" }}>*</span>
      </span>
    </InputLabel>
    <Select
      labelId="capcourseid-label"
      id="capcourseid"
      {...register("capcourseid", { required: "Course is required" })}
      defaultValue=""
      fullWidth
    >
      <MenuItem value="" disabled>
        Select Course
      </MenuItem>
      {capCourseList &&
        capCourseList.map((course) => (
          <MenuItem
            key={course.capcourseid?.toString()}
            value={course.capcourseid?.toString()}
          >
            {course.coursename}
          </MenuItem>
        ))}
    </Select>
    <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
      {errors?.capcourse?.message}
    </FormHelperText>
  </FormControl>
</Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("durationperslot", {
              required: "durationperslot  is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("durationperslot"),
            }}
            error={!!errors.durationperslot}
            helperText={errors.durationperslot?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                Duration per slot
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("durationperslot", value);
              trigger("durationperslot");
            }}
          />
        </Grid>
   
   
        <Grid item xs={12} md={6}>
          <TextField
            {...register("noofslots", {
              required: "noofslots  is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("noofslots"),
            }}
            error={!!errors.noofslots}
            helperText={errors.noofslots?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                Number per slot
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("noofslots", value);
              trigger("noofslots");
            }}
          />
        </Grid>
   
        <Grid item xs={12} md={6}>
          <TextField
            {...register("hoursperday", {
              required: "hoursperday  is required",
             
            })}
            InputLabelProps={{
              shrink: !!watch("hoursperday"),
            }}
            error={!!errors.hoursperday}
            helperText={errors.hoursperday?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"  
            fullWidth
            label={
              <span>
                Hours per day
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("hoursperday", value);
              trigger("hoursperday");
            }}
          />
        </Grid>
   

      </Grid>

            


      <Grid container spacing={3} mb={3}>
    
        {/* Log integer array if needed */}
        {/* <pre>{JSON.stringify(selectedDocs)}</pre> */}

        <Grid
          item
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        >
          <BackButton
            handleBack={() =>
              navigate(
                `/${Cookies.get(
                  "mhet_mst_project"
                )}/cap-course-management?page=capcourselist`
              )
            }
          />
          <BluePrimaryButton
            handleSubmit={handleSubmit(
              // capid ? handleUpdateCapVerifier : handleAddCourse
             handleAddCapVerifier
            )}
            // title={capid ? "Update" : "Submit"}
            title={"Submit"}
          />
        </Grid>
      </Grid>
    </>
  );
}
